module.exports = __webpack_public_path__ + "static/img/雷阵雨伴有冰雹.bd9033d0.svg";